import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/baseAxios';

export const getPortalReports = createAsyncThunk(
  'portalReport/getPortalReports',
  async () => {
    const response = await baseAxios.get('/PortalReport/GetPortalReport');
    return response.data;
  }
);

export const savePortalReportGuid = createAsyncThunk(
  'portalReport/savePortalReportGuid',
  async (portalReportGuidDto) => {
    const response = await baseAxios.post(
      '/PortalReport/SavePortalReportGuid',
      portalReportGuidDto
    );
    return response.data;
  }
);

const portalReportSlice = createSlice({
  name: 'portalReport',
  initialState: {
    loading: false,
    error: null,
    reports: [],
    saveResult: null
  },
  reducers: {
    clearPortalReportState: (state) => {
      state.loading = false;
      state.error = null;
      state.saveResult = null;
    }
  },
  extraReducers: {
    [getPortalReports.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [getPortalReports.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error?.message;
    },
    [getPortalReports.fulfilled]: (state, action) => {
      state.loading = false;
      state.reports = action.payload || [];
    },
    [savePortalReportGuid.pending]: (state) => {
      state.loading = true;
      state.error = null;
      state.saveResult = null;
    },
    [savePortalReportGuid.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error?.message;
    },
    [savePortalReportGuid.fulfilled]: (state, action) => {
      state.loading = false;
      state.saveResult = action.payload;
    }
  }
});

export const portalReportActions = portalReportSlice.actions;
export default portalReportSlice;
